class CustomerStory {
  customerStoryId: string = "";
  titleKo: string = "";
  titleEn: string = "";
  subTitleKo: string = "";
  subTitleEn: string = "";
  notionPageIdKo: string = "";
  notionPageIdEn: string = "";
  imageUrl: string = "";
  likedNum: number = 0;
  createdAt: Date = new Date();

  fromJson(response: { [x: string]: any }) {
    this.customerStoryId = response.customerStoryId ?? "";
    this.titleKo = response.titleKo ?? "";
    this.titleEn = response.titleEn ?? "";
    this.subTitleKo = response.subTitleKo ?? "";
    this.subTitleEn = response.subTitleEn ?? "";
    this.notionPageIdKo = response.notionPageIdKo ?? "";
    this.notionPageIdEn = response.notionPageIdEn ?? "";
    this.imageUrl = response.imageUrl ?? "";
    this.likedNum = response.likedNum ?? 0;
    this.createdAt = new Date(response.createdAt ?? "");
  }

  constructor(response?: { [x: string]: any }) {
    if (response) {
      this.fromJson(response);
    }
  }
}

export { CustomerStory };
